export enum ButtonColor {
  PRIMARY,
  DANGER,
}
